import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Layout,notification,Button } from 'antd';
import AppHeader from '../../components/appHeader/AppHeader';
import { ReloadOutlined } from '@ant-design/icons';
import MenuListComponent from '../../components/listComponent/MenuListComponent';
import { useNavigate } from 'react-router-dom';
import '../../styles/responsive.scss';


const AdminMenuList = () => {
    const [menuItemdata, setMenuItemData] = useState([]);
    const [subMenuItemdata, setSubMenuItemData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [storeId, setStoreId] = useState('');
    const [cusId, setCusId] = useState('');
    const [cusEmail, setCusEmail] = useState('');
    const navigate = useNavigate();


    const fethcMenuList = async () => {


        try{

        let token = sessionStorage.getItem('jwtToken'); // 从 sessionStorage 获取 JWT Token
        
        if (!token) {
            token = localStorage.getItem('jwtToken'); // 从 localStorage 获取 JWT Token
        }
        const config = {
            headers: {
                authorization: `Bearer ${token}`,
            },
        };


        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/fetchMenuList`, config);

        if (response.status === 200) {
        setCategoryData(response.data.categoryResult);
        setMenuItemData(response.data.menuItemsResult);
        setSubMenuItemData(response.data.subMenuLinksResult);
        setStoreId(response.data.storeInformation.storeId);
        setCusEmail(response.data.storeInformation.adminEmail);
        setCusId(response.data.storeInformation.adminId);
        }
        else {
            navigate('/qr_order/adminLogin');
        }
    }
    catch(error){
        navigate('/qr_order/adminLogin');
    
    }
}

    useEffect(() => {
        fethcMenuList();
    }, []);



    // const handleRefresh = () => {
    //     fethcMenuList();
    //   };
    return (
        <Layout className="layout" style={{ minHeight: '100vh' }}>
            <AppHeader email={cusEmail} cusId={cusId}/>
            <div className="table_list">
                <div className="admin_menu_list_header" style={{marginTop:"30px"}}>
                    
                    <h2>Menu List</h2>
                    
                    {/* <Button icon={<ReloadOutlined />} onClick={handleRefresh}>Refresh</Button> */}
                </div>
                <div className='admin_store_config'>
                {categoryData.length > 0 && menuItemdata.length>0 && <MenuListComponent title="Menu List" data={[categoryData,menuItemdata,subMenuItemdata,storeId]} />
                }
                </div>
            </div>
        </Layout>
    )
};
export default AdminMenuList;